var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "report_black_24dp",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8275",
    "data-name": "Path 8275",
    d: "M0,0H25.6V25.6H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8276",
    "data-name": "Path 8276",
    d: "M16.581,3H8.622L3,8.622v7.959L8.622,22.2h7.959L22.2,16.581V8.622ZM12.6,18.256a1.387,1.387,0,1,1,1.387-1.387A1.384,1.384,0,0,1,12.6,18.256Zm1.067-4.587H11.535v-6.4h2.134v6.4Z",
    transform: "translate(0.201 0.201)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/report.08bb0fc8.svg";
export { ForwardRef as ReactComponent };